import { Header } from '@crossfit/design-system'
import style from './style.module.scss'
import { Props } from './types'

function VideoList({ headlineText, videos }: Props) {
  return (
    <div className={style.wrapper}>
      <Header as={'h1'} size={'lg'} className={style.header}>
        {headlineText}
      </Header>
      <div className={style.videoList}>
        {videos.map((video) => (
          <div className={style.videoWrapper} key={video.youtubeId}>
            <iframe
              src={`https://www.youtube.com/embed/${video.youtubeId}`}
              title={video.title}
            ></iframe>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VideoList
